<template>
    <section>
        <h5 class="center-align">Home</h5>
    </section>
</template>

<script>
import navigation from "@/components/NavBar.vue";

export default {
    data() {
        return {};
    },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Home.vue